import DuckEntity from './DuckEntity';

export default function BaseUserJobs(nameOrDuck, options) {
  let duckOptions = options;

  if (typeof(nameOrDuck) === 'string') {
    const underscored = nameOrDuck.replace(/[A-Z]/g, x => '_' + x.toLowerCase());
    duckOptions = {
      apiPath: `user_jobs/${underscored}`,
      jsonRoot: underscored.endsWith('s') ? underscored.slice(0, -1) : underscored,
      jsonIndexRoot: underscored,
      ...duckOptions
    };
  }

  let cancel = false;
  const duck = new DuckEntity(nameOrDuck, duckOptions);

  /**
   * Polls the duck using the get action
   *
   * @param {object} job        The job object that is being polled for status
   * @param {number} interval   Time between consecutive polls
   * @param {number} retries    The number of poll attempts before a timeout (Used by default)
   * @param {number} timeout    The time before timeout (in ms). If this is defined this replaces the retries param
   * @returns
   *  A promise that resolves on complete or rejects on failure/timeout.
   */
  duck.actions.poll = (job, interval = 1000, retries = 3600, timeout) => (dispatch) => {
    let count = 0;

    const timedout = () => {
      if (timeout) {
        return count * interval > timeout;
      }
      return count > retries;
    };

    const executePoll = (resolve, reject) => {
      dispatch(duck.actions.get(job.id))
        .then(duck.actions.denormalizeObjects)
        .then(json => {
          count += 1;
          if (json.status === 'completed' || json.status === 'newly_completed') {
            return resolve(json);
          } else if (json.status === 'failed' || timedout()) {
            return reject({ status: (json.status === 'failed' ? 'failed' : 'timeout'), job: json });
          } else if (cancel) {
            cancel = false;
            return reject({ ...job, status: 'cancelled' });
          }
          return setTimeout(executePoll, interval, resolve, reject);
        })
        .catch(error => reject(error));
    };

    return new Promise(executePoll);
  };

  /**
   * Cancels a polling action
   */
  duck.actions.cancelPoll = () => () => {
    cancel = true;
  };

  return duck;
}
